import Shortcode from './Shortcode';

export default class ProductCTA extends Shortcode {
  static get shortcode() {
    return 'product-cta';
  }

  constructor(el) {
    super();

    this.productFormEl = null;
    let parentEl = el.parentElement;

    while (parentEl) {
      this.productFormEl = parentEl.hasAttribute('[data-product-form]') ? parentEl : parentEl.querySelector('[data-product-form]');

      if (this.productFormEl) break;

      parentEl = parentEl.parentElement;
    }

    if (!this.productFormEl) {
      throw new Error('ProductCTA: No product form found.');
    }

    // Keep a reference to shortcode element to unhide
    this.el = el;

    this.variantId = el.getAttribute('variant-id');

    // Build the call to action element
    this.ctaEl = document.createElement('a');
    this.ctaEl.classList.add('shortcode--product-cta');
    if (el.getAttribute('button-style')) {
      this.ctaEl.setAttribute('button-style', el.getAttribute('button-style'));
    }
    if (el.getAttribute('button-size')) {
      this.ctaEl.setAttribute('button-size', el.getAttribute('button-size'));
    }
    this.ctaEl.href = el.getAttribute('link');
    this.ctaEl.innerHTML = el.innerHTML;

    // Remove element from DOM and insert new element into position
    this.el.toggleAttribute('hidden', true);
    this.productFormEl.parentNode.insertBefore(this.ctaEl, this.productFormEl.nextSibling);

    if (this.variantId) {
      const variantsEl = this.productFormEl.querySelector('[data-variants]');
      this._registerEvent({ el: variantsEl, event: 'change', listener: this._onVariantChange.bind(this) });
      this._setVisible(variantsEl.value === this.variantId);
    } else {
      this._setVisible(true);
    }
  }

  unload() {
    super.unload();

    this.productFormEl.parentNode.removeChild(this.ctaEl);
    this.el.toggleAttribute('hidden', false);
  }

  _setVisible(visible) {
    this.ctaEl.toggleAttribute('hidden', !visible);
  }

  _onVariantChange(e) {
    this._setVisible(e.currentTarget.value === this.variantId);
  }
}
